module.exports = __webpack_public_path__ + "assets/images/UNFIT100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT100.png
// module id = 1440
// module chunks = 1